import * as actions from '../constants/actions'
import { createReducer } from '../utils/redux'

export default createReducer(null, {

    [actions.LOAD_LIGHT_STOMPUNKTER_SUCCESS]: (state, action) => action.view

})


// WEBPACK FOOTER //
// ./src/reducers/seenViews.js